/** Sprint S13.3.A — post-checkout success landing. Auto-redirects home
 *  after 5s (lets the webhook process). Default export; billing.* i18n. */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function BillingSuccessPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => navigate("/"), 5000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="mx-auto flex min-h-dvh max-w-md flex-col justify-center px-5 py-10 text-center">
      <div className="mb-4 text-5xl">🎉</div>
      <h1 className="font-serif text-2xl font-medium text-navy">
        {t("billing.success.title")}
      </h1>
      <p className="mt-2 text-[15px] text-taupe">
        {t("billing.success.subtitle")}
      </p>
      <p className="mt-4 text-sm text-taupe">
        {t("billing.success.redirect_notice")}
      </p>
    </div>
  );
}
